import React from 'react'
import PublicLiveAgoraVideoSurface from './PublicLiveAgoraVideoSurface'

export default function StandardLiveAgoraVideoSurface(props) {
  return <PublicLiveAgoraVideoSurface {...props} />
}

StandardLiveAgoraVideoSurface.displayName = 'StandardLiveAgoraVideoSurface'
